import { useState } from 'react';

const Toggle = (props) => {
    const { title, open: defaultOpen = false, onToggle = () => {}, children } = props;
    const [open, setopen] = useState(defaultOpen);
    const toggleOpen = () => {
        setopen(!open);
        onToggle();
    };
    return (
        <div className={'toggle' + (open ? ' open' : '')} tabIndex={0}>
            <div className="toggle-title" onClick={toggleOpen}>
                <div className="title-text">{title}</div>
                <button tabIndex="0" className="icon" title={'Click to Toggle Data Table'}></button>
            </div>
            <div className={'toggle-content'}>
                <div className="toggle-inner">{children}</div>
            </div>
        </div>
    );
};
export default Toggle;
